export const txtMimeTypes = ["text/plain"];
